import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ResetPasswordPage is no longer needed — the entire forgot-password flow
 * (email → OTP → new password) is now handled inside ForgotPasswordPage.
 * This page redirects any old /reset-password links to /forgot-password.
 */
const ResetPasswordPage = () => {
  return <Navigate to="/forgot-password" replace />;
};

export default ResetPasswordPage;
